module.exports = __webpack_public_path__ + "img/add_lock_3.a1f52cf8.png";